import React from 'react';
import Phone from '@mui/icons-material/Phone';
import * as R from 'ramda';
import {CountryCode} from 'libphonenumber-js/min';
import {styled as muiStyled, styled} from '@mui/material/styles';
import {PhoneNumberInput} from '@practicegenius/pg-ui/src/base/Material/components/PhoneNumberField';
import {RegisterPhoneNumberScreenType} from '@practicegenius/register-account/src/screens/RegisterPhoneNumber';
import {loginBottomText} from '../components/layout';
import {usePhpJs} from '../../../utils/php-js';
import {TextButton} from '../../../components/TextButton';
import {ProgressScreen} from '../../../components/screens/BaseScreen';

const HeadspaceText = styled('p')({
  marginTop: '1rem',
});

const ActionText = muiStyled(TextButton)(({theme}) => ({
  color: theme.palette.primary.main,
}));

export const RegisterPhoneNumber: RegisterPhoneNumberScreenType = ({
  actionButtons: {primary, secondary},
  alternativePhonePrompt,
  instructions,
  lang: {headerTitle, pageTitle},
  onFormSubmit,
  phoneInputProps,
  progress,
  title,
  userCountryCode,
}) => {
  const practiceCountryCode = usePhpJs(R.pathOr('US', ['practice', 'country']));

  return (
    <form onSubmit={onFormSubmit}>
      <ProgressScreen
        helmetTitle={pageTitle}
        headerTitle={headerTitle}
        title={title}
        instructions={instructions}
        progress={progress}
        actionButtons={[primary, secondary]}
        cancelProps={{href: '/'}}
        bottomText={loginBottomText}
      >
        <PhoneNumberInput
          {...phoneInputProps}
          countryCode={
            (userCountryCode as CountryCode) ??
            (practiceCountryCode as CountryCode)
          }
          icon={Phone}
          value={phoneInputProps.value ?? undefined}
          onChange={e => phoneInputProps.onChange(e.target.value)}
          autoFocus
        />
        {alternativePhonePrompt && (
          <HeadspaceText>
            {alternativePhonePrompt.label}{' '}
            <ActionText onClick={alternativePhonePrompt.onClick}>
              {alternativePhonePrompt.linkText}
            </ActionText>
          </HeadspaceText>
        )}
      </ProgressScreen>
    </form>
  );
};
